// src/components/dashboard/AdminNewsTab.jsx
import React, { useState } from 'react';
import { newsService } from '../../services/api';

const initialNewsState = { title: '', summary: '', body: '', active: true, date: new Date().toISOString().split('T')[0] };

export default function AdminNewsTab({ data: news, setData: setNews, actionLoading, setActionLoading, setError }) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentNews, setCurrentNews] = useState(initialNewsState);

    const handleSave = async (e) => {
        e.preventDefault();
        if (actionLoading) return;
        setActionLoading(true);
        setError(null);

        try {
            let result;
            if (currentNews.id) {
                result = await newsService.updateNewsItem(currentNews.id, currentNews);
                setNews(prev => prev.map(n => n.id === currentNews.id ? result.data || result : n));
            } else {
                result = await newsService.createNewsItem(currentNews);
                setNews(prev => [...prev, result.data || result]);
            }
            setCurrentNews(initialNewsState);
            setIsFormVisible(false);
        } catch (err) {
            setError('Error al guardar la Noticia.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de esta Noticia?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            await newsService.deleteNewsItem(id); 
            setNews(prev => prev.filter(n => n.id !== id));
        } catch (err) {
            setError('Error al inactivar la Noticia.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleEdit = (item) => { setCurrentNews({ ...item, date: new Date(item.date).toISOString().split('T')[0] }); setIsFormVisible(true); };
    const handleNew = () => { setCurrentNews(initialNewsState); setIsFormVisible(true); };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Noticias</h4>
            <button onClick={handleNew} className="mb-4 btn btn-green" disabled={actionLoading}>Crear Nueva Noticia</button>

            {isFormVisible && (
                <form onSubmit={handleSave} className="mb-6 p-4 border rounded bg-gray-50 space-y-3 max-w-2xl">
                    <h5 className="font-bold">{currentNews.id ? 'Editar Noticia' : 'Nueva Noticia'}</h5>
                    
                    <input type="text" placeholder="Título" value={currentNews.title} onChange={(e) => setCurrentNews({ ...currentNews, title: e.target.value })} required className="input-field" disabled={actionLoading} />
                    <input type="date" value={currentNews.date} onChange={(e) => setCurrentNews({ ...currentNews, date: e.target.value })} required className="input-field max-w-[200px]" disabled={actionLoading} />
                    <textarea placeholder="Resumen" value={currentNews.summary} onChange={(e) => setCurrentNews({ ...currentNews, summary: e.target.value })} rows="2" className="input-field" disabled={actionLoading} />
                    <textarea placeholder="Cuerpo/Detalle (Opcional)" value={currentNews.body} onChange={(e) => setCurrentNews({ ...currentNews, body: e.target.value })} rows="5" className="input-field" disabled={actionLoading} />

                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>{actionLoading ? 'Guardando...' : 'Guardar Noticia'}</button>
                        <button type="button" onClick={() => setIsFormVisible(false)} className="btn btn-secondary" disabled={actionLoading}>Cerrar</button>
                    </div>
                </form>
            )}

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Título</th>
                            <th className="table-th">Fecha</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {news.map((n) => (
                            <tr key={n.id}>
                                <td className="table-td">{n.title}</td>
                                <td className="table-td">{new Date(n.date).toLocaleDateString()}</td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(n)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(n.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}